import { Component, OnInit } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { UsersService } from '../services/users.service';
import { Subscriber, Subscription } from 'rxjs';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  providers: [
    UsersService
  ]
})
export class RegisterComponent implements OnInit {

  public showTerms: boolean = false;
  loggedInUser: Object;
  loginError: String;
  newUser: Object = {
    profile: {}
  };

  constructor(private UsersService: UsersService, private router: Router) { }

  ngOnInit() {

  }

  registerUser(newUser): void {
    if(!newUser.profile.firstName){
      this.loginError = "Please enter your name."
    }
    else {
      this.UsersService.registerUser(newUser).subscribe( data => {
        this.router.navigate(['/home']);
      },
      err => {
        if(err.error.errors){
          this.loginError = err.error.errors[0].msg;
        }
        else {
          this.loginError = err.error.error;
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// /Users/cullenkirkpatrick/Documents/Goals/goal-project/src/app/register/register.component.ts